export default __webpack_public_path__ + "6b9dc1a807e40120aed1ac2ae6692a6f.png";